/* Melrose Essentials — site fixes 2026-09-10 (Brett's punch list)
 *
 * 2) PDP gallery: switching Single <-> 2 Pack animated (scrolled) through every
 *    slide on the way to the new variant's photo. Embla's scrollTo(index, jump)
 *    takes a second argument: true = instant. The theme's EmblaComponent
 *    .slideToIndex() never passes it, so we patch the prototype and make the
 *    variant-driven jump instant. On the desktop stacked layout the theme
 *    scrolled the page itself (scrollIntoView) - now suppressed entirely.
 *
 * 3) PDP: Seal's "Subscription details" popup opened on hover on desktop.
 *    Toggle it on click instead (.me-sub-open, styled in me-site-fixes.css) and
 *    stop the label's anchor from navigating to sealsubscriptions.com.
 *    Mobile behaviour (Seal's own .sls-show on tap) is untouched.
 */
(function () {
  if (window.__meSiteFixes) return;
  window.__meSiteFixes = true;

  /* ---------------------------------------------------------------- gallery */
  function patchGallery() {
    var Embla = window.customElements && customElements.get('embla-component');
    var Gallery = window.customElements && customElements.get('media-gallery');
    if (!Embla || !Gallery || Embla.prototype.__meJump) return false;

    Embla.prototype.__meJump = true;
    Embla.prototype.slideToIndex = function (index, jump) {
      if (!this.emblaApi) return;
      // default to an instant jump; the arrows/drag do not go through here
      this.emblaApi.scrollTo(Number(index), jump === undefined ? true : jump);
    };

    Gallery.prototype.updateGalleryThumbs = function (activeMedia) {
      var wide = window.matchMedia('(min-width: 990px)').matches;
      this.elements.media.forEach(function (el) {
        el.classList.remove('is-active');
      });
      if (activeMedia) activeMedia.classList.add('is-active');

      if (wide && this.desktopStacked) {
        /* Brett 2026-09-10: the theme scrolled the *page* to the newly active
           media on every variant change, which read as the page jumping up.
           Marking the media active is enough; the page stays where the shopper
           left it. */
        return;
      } else {
        this.updateSlider(activeMedia);
      }
    };
    return true;
  }

  /* ------------------------------------------------- Seal subscription info */
  function hoverCapable() {
    return window.matchMedia('(hover: hover)').matches;
  }

  function closeAll(except) {
    document.querySelectorAll('.sls-more-info-text.me-sub-open').forEach(function (el) {
      if (el !== except) el.classList.remove('me-sub-open');
    });
  }

  function bindSeal() {
    document.addEventListener(
      'click',
      function (event) {
        if (!hoverCapable() || !event.target.closest) return;

        var wrap = event.target.closest('.sls-more-info-text');
        if (!wrap) {
          closeAll(null);
          return;
        }
        // clicks inside the open popup should not close it, except the X
        if (event.target.closest('.sls-close')) {
          event.preventDefault();
          wrap.classList.remove('me-sub-open');
          return;
        }
        if (event.target.closest('.sls-more-info-popup')) return;

        event.preventDefault(); // the label wraps a link to sealsubscriptions.com
        closeAll(wrap);
        wrap.classList.toggle('me-sub-open');
      },
      true
    );

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAll(null);
    });
  }


  /* -------------------------------------------------------------------------
     9) Sticky cart bar — MIRROR build (Brett's option (a), 2026-09-11 17:02 PT).
        Replaces Seal's 343px duplicated block with one compact row that mirrors
        the main buy box: pack, charged price, One-time / Subscribe toggle, and an
        Add to cart button that clicks the MAIN form's submit. The main form stays
        the only source of truth, so neither of the two defects found on 2026-09-10
        (sticky variant id drifting from the pack choice; Subscribe & Save
        pre-checked in the sticky form) can return. Reveal timing is the theme's
        again — the bar appears once the shopper scrolls past the buy box.
     ---------------------------------------------------------------------- */

  var VARIANTS = null;

  function mainForm() {
    var forms = [].slice.call(document.querySelectorAll('form[action="/cart/add"]'));
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].closest('sticky-cart')) continue;
      if (forms[i].querySelector('button[name="add"], .product-form__submit')) return forms[i];
    }
    return null;
  }

  function mainRadios() {
    return [].slice
      .call(document.querySelectorAll('input[type="radio"][name^="subs_type"]'))
      .filter(function (r) {
        return !r.closest('sticky-cart');
      });
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* Price actually charged for the current selection. The theme's own price block is
   * the honest source: Seal rewrites it to the discounted figure when a plan is picked
   * (2 Pack + Subscribe reads $194.65, not $229.00 — a mismatch I caught in testing on
   * 2026-09-11). Sale price first, then the last money value printed, then the variant. */
  function currentPrice(form, id) {
    var block = document.querySelector('.product__info-container .price');
    if (block) {
      /* The block holds both a .price__regular and a hidden .price__sale copy, and on a
       * subscription it prints the compare-at price struck through next to the charged
       * one. Only take a figure that is actually rendered and not struck through. */
      var live = [].slice.call(block.querySelectorAll('.price-item')).filter(function (el) {
        if (el.getBoundingClientRect().height <= 0) return false;
        /* Seal marks the was-price with .price__compare. Don't test for line-through:
         * when the block is seal-synced the charged price inherits it too (measured
         * 2026-09-11: $254.00 compare AND $194.65 charged both report line-through). */
        return (el.className || '').toString().indexOf('price__compare') < 0;
      });
      for (var i = live.length - 1; i >= 0; i--) {
        var m = (live[i].textContent || '').match(/\$[\d,]+\.\d{2}/);
        if (m) return m[0];
      }
    }
    var v = VARIANTS && id ? VARIANTS[String(id)] : null;
    return v ? money(v.price) : '';
  }

  function isSubscribed(form) {
    var plan = form.querySelector('input[name="selling_plan"]');
    return !!(plan && plan.value);
  }

  function syncSticky() {
    var sc = document.querySelector('sticky-cart');
    var form = mainForm();
    if (!sc || !form) return;
    var row = sc.querySelector('.me-sc-row');
    if (!row) return;

    var idInput = form.querySelector('input[name="id"]');
    var id = idInput ? idInput.value : null;
    var v = VARIANTS && id ? VARIANTS[String(id)] : null;
    var sub = isSubscribed(form);

    row.querySelector('.me-sc-pack').textContent = v ? v.title : '';
    row.querySelector('.me-sc-price').textContent = currentPrice(form, id);

    var plans = row.querySelectorAll('.me-sc-plan');
    for (var i = 0; i < plans.length; i++) {
      var wantsSub = plans[i].getAttribute('data-plan') === 'sub';
      plans[i].setAttribute('aria-pressed', String(wantsSub === sub));
      plans[i].classList.toggle('is-on', wantsSub === sub);
    }
  }

  function pickPlan(wantsSub) {
    var radios = mainRadios();
    for (var i = 0; i < radios.length; i++) {
      var isOneTime = radios[i].value === 'one_time';
      if (wantsSub ? !isOneTime : isOneTime) {
        if (!radios[i].checked) radios[i].click();
        break;
      }
    }
    /* Seal rewrites the price block asynchronously; a single 120ms sync can read the
     * pre-discount figure, and a stale price is worse than a late one. */
    [120, 400, 900, 1600].forEach(function (ms) {
      setTimeout(syncSticky, ms);
    });
  }

  function buildStickyRow() {
    var sc = document.querySelector('sticky-cart');
    var form = mainForm();
    if (!sc || !form) return false;
    if (sc.querySelector('.me-sc-row')) return true;

    var row = document.createElement('div');
    row.className = 'me-sc-row';
    row.innerHTML =
      '<div class="me-sc-main">' +
      '<div class="me-sc-text">' +
      '<span class="me-sc-title">Melrose Relieve</span>' +
      '<span class="me-sc-meta"><span class="me-sc-pack"></span>' +
      '<span class="me-sc-price"></span></span></div>' +
      '<button type="button" class="me-sc-btn">Add to cart</button>' +
      '</div>' +
      '<div class="me-sc-plans" role="group" aria-label="Purchase options">' +
      '<button type="button" class="me-sc-plan" data-plan="one_time">One-time</button>' +
      '<button type="button" class="me-sc-plan" data-plan="sub">Subscribe &middot; save 15%</button>' +
      '</div>';
    sc.appendChild(row);

    row.querySelector('.me-sc-btn').addEventListener('click', function () {
      var submit = mainForm() && mainForm().querySelector('button[name="add"], .product-form__submit');
      if (submit) submit.click();
    });
    var plans = row.querySelectorAll('.me-sc-plan');
    for (var i = 0; i < plans.length; i++) {
      plans[i].addEventListener('click', function (e) {
        pickPlan(e.currentTarget.getAttribute('data-plan') === 'sub');
      });
    }

    var mo = new MutationObserver(syncSticky);
    mo.observe(form, { childList: true, subtree: true, attributes: true });
    document.addEventListener('change', syncSticky, true);
    document.addEventListener('click', function () {
      setTimeout(syncSticky, 200);
    }, true);
    setInterval(syncSticky, 500);
    syncSticky();
    return true;
  }

  function initSticky() {
    if (!document.body.classList.contains('template-product')) return;
    fetch(window.location.pathname.split('?')[0] + '.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (p) {
        VARIANTS = {};
        (p.variants || []).forEach(function (v) {
          VARIANTS[String(v.id)] = { title: v.title, price: v.price };
        });
        syncSticky();
      })
      .catch(function () {});
    if (!buildStickyRow()) {
      var tries = 0;
      var t = setInterval(function () {
        if (buildStickyRow() || ++tries > 60) clearInterval(t);
      }, 200);
    }
  }

  function init() {
    if (!patchGallery()) {
      var tries = 0;
      var timer = setInterval(function () {
        if (patchGallery() || ++tries > 40) clearInterval(timer);
      }, 100);
    }
    bindSeal();
    initSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
